import { navigateTo } from 'utils/navigation';
import { store } from 'store';

const AUTH_KEY = 'pp_access_token';

export function getAuthToken() {
  return localStorage.getItem(AUTH_KEY);
}

export function setAuthToken(token) {
  return localStorage.setItem(AUTH_KEY, token);
}

export function removeTokens() {
  localStorage.removeItem(AUTH_KEY);
}

export function isSignedIn() {
  let authToken = getAuthToken();

  return (authToken != null) ? true : false
}

export function getPatient() {
  const state = store.getState();

  return state.Patient.patients.get("patient");
}

export function getPractice() {
  const patient = getPatient();
  const { practice: { data: { attributes: practiceInfo } } } = patient;

  return practiceInfo;
}

export function resetAuth() {
  removeTokens()
  store.dispatch({ type: 'RESET_STATE' })
}

export function sessionExpired() {
  resetAuth()
  navigateTo('/session-expired', { replace: true })
}
